import { render, staticRenderFns } from "./StepperBreadcrumb.vue?vue&type=template&id=2bc16008&scoped=true"
import script from "./StepperBreadcrumb.vue?vue&type=script&lang=js"
export * from "./StepperBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./StepperBreadcrumb.vue?vue&type=style&index=0&id=2bc16008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc16008",
  null
  
)

export default component.exports